import React, { useState, useEffect } from 'react';
import '../index.scss';
import '../home.scss';
import tight1664logo from '../assets/logo/tight1664logo.png';
import supabase from '../helper/supabaseClient';
import { Link } from 'react-router-dom';

function PasswordReset() {
  const [isRecovery, setIsRecovery] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setIsRecovery(true); // Show the password reset form
      }
    });

    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");

    if (password !== repeatPassword) {
      setError("Passwords do not match.");
      return;
    }

    const { data, error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError("There was an error updating your password.");
    } else {
      setMessage("Password reset complete. You can now log in.");
      setPassword("");
      setRepeatPassword("");
    }
  };

  return (
    <div className="homepage">
      <div className="grid-left">
        <img src={tight1664logo} alt="1664 Logo" />
        <h1 style={{ fontSize: "2rem" }}>WELCOME TO THE <br />1664 PRACTITIONER PORTAL</h1>
      </div>

      <div className="grid-right">
        <h2 style={{ fontSize: "1.6rem" }}>RESET YOUR PASSWORD</h2>

        {!isRecovery ? (
          <p>Please follow the password reset link from your email to access this page.</p>
        ) : (
          <>
            <form className="reset" onSubmit={handleSubmit}>
              <input
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <br />
              <input
                type="password"
                placeholder="Repeat New Password"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
                required
              />
              <br />
              <button type="submit">Reset Password</button>
            </form>
          </>
        )}

        <br />
        {message && <p className="success">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        <p>Remembered your password? <Link to="/">Click here to login.</Link></p>
      </div>
    </div>
  );
}

export default PasswordReset;